var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgProgressArrow = function SvgProgressArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 17,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.415 8.5.237 15.176a1.127 1.127 0 0 0 .21 1.589 1.15 1.15 0 0 0 1.602-.207L7.763 9.19a1.126 1.126 0 0 0 0-1.382L2.049.442A1.15 1.15 0 0 0 .446.235a1.127 1.127 0 0 0-.209 1.59L5.415 8.5z",
    fill: "#142B68",
    opacity: 0.179
  })));
};

export default SvgProgressArrow;